import { gatshipSearchOperatorsMetadata } from '@gat-ship/search'
import type { GatshipSearchOperator } from '@gat-ship/types'

/**
 * Get the value of a search operator.
 *
 * @param operator - The operator to get the value for.
 * @returns The value of the operator (without the colon prefix).
 */
export function getSearchOperatorValue(
  operator: GatshipSearchOperator
): string {
  return gatshipSearchOperatorsMetadata[operator].operatorValue
}
